<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center">OREP Private <br> Investigators Insurance Program</h1>
          <h2>OREP Insurance Services, LLC
              investigators@orep.org
              (888)-347-5273</h2>
        </article>
        <article>
          <label for class="form-heading title-section form-section flex">
            <h1 class="form-title">General Application infomation</h1>
          </label>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
              <span class="mr-1">1.</span>Name of Applicant:
            </label>
            <input
              type="text"
              name="nameOfApplicant"
              v-model="sipApplication.nameOfApplicant"
              class="orep-text-input w-100"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
            >
            <span
              v-show="errors.has('nameOfApplicant')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('nameOfApplicant') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">Business Entity Type: </label>
            <div class="radio orep-radio-wrapper">
              <label>
                <input
                  type="radio"
                  name="businessEntityType"
                  value="corporation"
                  class="orep-radio"
                  v-validate="'required|included:corporation,llc,soleProprietor,other'"
                  @change="validateBeforeSubmit()"
                  v-model="sipApplication.businessEntityType"
                >
                <span class="radio-span">Corporation</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper">
              <label>
                <input
                  type="radio"
                  name="businessEntityType"
                  value="llc"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="sipApplication.businessEntityType"
                >
                <span class="radio-span">Limited Liability Company</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper">
              <label>
                <input
                  type="radio"
                  name="businessEntityType"
                  value="soleProprietor"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="sipApplication.businessEntityType"
                >
                <span class="radio-span">Individual / Sole Proprietor</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper">
              <label>
                <input
                  type="radio"
                  name="businessEntityType"
                  value="other"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="sipApplication.businessEntityType"
                >
                <span class="radio-span">Other</span>
              </label>
            </div>
            <span
              v-show="errors.has('businessEntityType')"
              class="help is-danger form-errors text-danger mt-0 mb-2"
            >{{ errors.first('businessEntityType') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            Contact Name:
          </label>
          <input
            type="text"
            name="contactName"
            v-model="sipApplication.customer.contactName"
            class="orep-text-input w-100"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('contactName')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('contactName') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section">
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label ml-1">
                  Website:
                </label>
                <input
                  type="text"
                  name="website"
                  v-model="sipApplication.website"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-6">
                <label for class="orep-label ml-1">
                  Email:
                </label>
                <input
                  type="email"
                  name="email"
                  v-model="sipApplication.customer.email"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('email')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('email') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label ml-1">
                  Physical Address:
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="sipApplication.customer.address"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('address')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="sipApplication.customer.city"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('city')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="state"
                  v-model="sipApplication.customer.state"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('state')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  ZIP Code:
                </label>
                <input
                  type="text"
                  name="zipCode"
                  v-model="sipApplication.customer.zipCode"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('zipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>

            </div>
            <label for class="orep-label ml-1">
                  Mailing Address:
                </label>
            <div class="row pb-3">
              <div class="col-md-12">               
                <input
                  type="text"
                  name="mailingAddress"
                  v-model="sipApplication.mailingAddress"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('mailingAddress')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingAddress') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  City:
                </label>
                <input
                  type="text"
                  name="mailingCity"
                  v-model="sipApplication.mailingCity"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('mailingCity')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingCity') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="mailingState"
                  v-model="sipApplication.mailingState"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('mailingState')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingState') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  ZIP Code:
                </label>
                <input
                  type="text"
                  name="mailingZipCode"
                  v-model="sipApplication.mailingZipCode"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('mailingZipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingZipCode') | filterText }}</span>
              </div>

            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label">
                  <span class="qtn mrpx-5"></span>Business Phone Number:
                </label>
                <input
                  type="text"
                  name="businessPhone"
                  v-model="sipApplication.businessPhone"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('businessPhone')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('businessPhone') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label">
                  <span class="qtn mrpx-5"></span>Fax:
                </label>
                <input
                  type="text"
                  name="fax"
                  v-model="sipApplication.customer.fax"
                  class="orep-text-input w-100"
                >
              </div>
              <div class="col-md-4">
                <label for class="orep-label">
                  <span class="mr-1"></span>Cell Phone:
                </label>
                <input
                  type="text"
                  name="phone"
                  v-model="sipApplication.customer.phone"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('phone')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('phone') | filterText }}</span>
              </div>

            </div>
          </div>

        </article>
        <article class="form-section">
          <div class="input-section">
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label">
                  Federal ID Number:
                </label>
                <input
                  type="text"
                  name="federalId"
                  v-model="sipApplication.federalId"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('federalId')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('federalId') | filterText }}</span>
              </div>
              <div class="col-md-4">
                  <label for class="orep-label">
                    Date Established:
                  </label>

                <input
                  type="text"
                  name="dateEstablished"
                  v-model="sipApplication.dateEstablished"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('dateEstablished')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('dateEstablished') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label">
                  Years Experience:
                </label>

                <input
                  type="text"
                  name="yearsExperience"
                  v-model="sipApplication.yearsExperience"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('yearsExperience')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('yearsExperience') | filterText }}</span>
              </div>            
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label">
                  Please list all Associations, Memberships and Certifications:
                </label>

                <input
                  type="text"
                  name="listMembershipAndCertifications"
                  v-model="sipApplication.listMembershipAndCertifications"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('listMembershipAndCertifications')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('listMembershipAndCertifications') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-3 col-sm-6">
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.apia"
                    >
                    <span class="radio-span solo-checkbox-span no-top">APIA</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.cali"
                    >
                    <span class="radio-span solo-checkbox-span no-top">CALI</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.tali"
                    >
                    <span class="radio-span solo-checkbox-span no-top">TALI</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.fapi"
                    >
                    <span class="radio-span solo-checkbox-span no-top">FAPI</span>
                  </label>
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.nafi"
                    >
                    <span class="radio-span solo-checkbox-span no-top">NAFI</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.napps"
                    >
                    <span class="radio-span solo-checkbox-span no-top">NAPPS</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.ncapi"
                    >
                    <span class="radio-span solo-checkbox-span no-top">NCAPI</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.nciss"
                    >
                    <span class="radio-span solo-checkbox-span no-top">NCISS</span>
                  </label>
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.fali"
                    >
                    <span class="radio-span solo-checkbox-span no-top">FALI</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.pali"
                    >
                    <span class="radio-span solo-checkbox-span no-top">PALI</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.ppiac"
                    >
                    <span class="radio-span solo-checkbox-span no-top">PPIAC</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.piai"
                    >
                    <span class="radio-span solo-checkbox-span no-top">PIAI</span>
                  </label>
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.piava"
                    >
                    <span class="radio-span solo-checkbox-span no-top">PIAVA</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.pasco"
                    >
                    <span class="radio-span solo-checkbox-span no-top">PASCO</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox">
                  <label class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="membership"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.scali"
                    >
                    <span class="radio-span solo-checkbox-span no-top">SCALI</span>
                  </label>
                </div>
              </div>
            </div>
          </div>      
        </article>
        <article>
          <label for class="form-heading title-section form-section flex">
            <h1 class="form-title">Operations</h1>
          </label>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
            <p class="d-flex align-items-center">If you are active in these activities, Please Call: (888 347-5273)</p>
            <div class="row pb-3">
              <div class="col-md-3">Collection Agency</div>
              <div class="col-md-2">Claims Adjuster</div>
              <div class="col-md-2">Title Abstracting</div>
              <div class="col-md-2">Bail Bonding</div>
              <div class="col-md-3">Automobile Repossessions</div>
            </div>  
            <div class="row pb-3">
              <div class="col-md-3">Alarm/Security installation & monitoring services</div>
              <div class="col-md-2">Body Guard - High Profile</div>
              <div class="col-md-2">Security Guard</div>
              <div class="col-md-2">Bail Bonding</div>
              <div class="col-md-3">Bounty Hunters/Fugitive Recovery</div>
            </div>            
          </label>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            2.  Please provide the percentage of revenue from each type of operation below:
          </label>
          <div class="row operation-wrapper">
            <div class="item col-md-4">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="accidentReconstruction"
                    v-model="sipApplication.accidentReconstruction"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Accident Reconstruction</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="accountingForensic"
                    v-model="sipApplication.accountingForensic"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Accounting Forensic / AML</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="arsonPropertyInvestigations"
                    v-model="sipApplication.arsonPropertyInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Arson / Property Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="attorneyLegalInvestigations"
                    v-model="sipApplication.attorneyLegalInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Attorney / Legal Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="backgroundInvestigations"
                    v-model="sipApplication.backgroundInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Background Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="computerForensic"
                    v-model="sipApplication.computerForensic"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Computer Forensic</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="conservatorOfPeace"
                    v-model="sipApplication.conservatorOfPeace"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Conservator of Peace (SCOP)</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="constableServices"
                    v-model="sipApplication.constableServices"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Constable Services</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="consulting"
                    v-model="sipApplication.consulting"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Consulting</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="copyrightTrademarkInvestigations"
                    v-model="sipApplication.copyrightTrademarkInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Copyright / Trademark Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="cyberSecurityInfiltration"
                    v-model="sipApplication.cyberSecurityInfiltration"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% NFL Consulting</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="other"
                    v-model="sipApplication.other"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Other (Write in Below)</label>
                </label>
              </div>
            </div>
            <div class="item col-md-4">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="debuggingTscm"
                    v-model="sipApplication.debuggingTscm"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Debugging / TSCM</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="executiveProtection"
                    v-model="sipApplication.executiveProtection"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Executive Protection - Low Profile</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="exitingInterview"
                    v-model="sipApplication.exitingInterview"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Exiting Interview (Corporate)</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="expertWitnessServices"
                    v-model="sipApplication.expertWitnessServices"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Expert Witness Services</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="fidelityInvestigations"
                    v-model="sipApplication.fidelityInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Fidelity Investigations / Domestic</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="fingerprintAnalysis"
                    v-model="sipApplication.fingerprintAnalysis"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Fingerprint Analysis</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="firearmsTrainingClassRoom"
                    v-model="sipApplication.firearmsTrainingClassRoom"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Firearms Training - Classroom Only</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="firearmsTrainingRange"
                    v-model="sipApplication.firearmsTrainingRange"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Firearms Training - Range</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="genealogy"
                    v-model="sipApplication.genealogy"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Genealogy</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="insuranceInvestigations"
                    v-model="sipApplication.insuranceInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Insurance Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="juvenileInvestigations"
                    v-model="sipApplication.juvenileInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Juvenile Investigations</label>
                </label>
              </div>
            </div>
            <div class="item col-md-4">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="kidnapAndRamson"
                    v-model="sipApplication.kidnapAndRamson"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Kidnap and Ramson</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="lieDetectionPolygraph"
                    v-model="sipApplication.lieDetectionPolygraph"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Lie Detection / Polygraph</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="locateSkipTrace"
                    v-model="sipApplication.locateSkipTrace"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Locate / SkipTrace</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="mortgageCourtAuctionServices"
                    v-model="sipApplication.mortgageCourtAuctionServices"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Mortgage/Court - Auction Services</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="onlineSearches"
                    v-model="sipApplication.onlineSearches"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Online Searches</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="processServiceSubpoena"
                    v-model="sipApplication.processServiceSubpoena"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Process Service / Subpoena</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="securityTraining"
                    v-model="sipApplication.securityTraining"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Security Training</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="shoppingServicesMysteryShopping"
                    v-model="sipApplication.shoppingServicesMysteryShopping"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Shopping Services/Mystery Shopping</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="subRosaInvestigations"
                    v-model="sipApplication.subRosaInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Sub-Rosa Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="threatVulnerabilityAssessment"
                    v-model="sipApplication.threatVulnerabilityAssessment"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-4">% Threat/Vulnerability Assessment</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="underCoverInvestigations"
                    v-model="sipApplication.underCoverInvestigations"
                    class="orep-text-input mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Under Cover Investigations</label>
                </label>
              </div>
            </div>
            <div class="col-md-12 item">
              <input
              type="text"
              name="percentageOther"
              v-model="sipApplication.percentageOther"
              class="orep-text-input w-100"
              @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('percentageOther')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('percentageOther') | filterText }}</span>
            </div>
          </div>            

        </article>
      </form>
    </section>
    <section class="bottom-section">
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('sip-application-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('sip-application-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('sip-application-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid|| !state.pageThreeIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('sip-application-2')">Next</button>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery";
import {APP_STATUS, STATES} from "../../utils/constants";

export default {
  name: "sip-application-1",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    sipApplication() {
      return this.$store.state.sipApplication.sipApplication;
    },
    state() {
      return this.$store.state.sipApplication;
    },
    errorMsg() {
      return this.$store.state.sipApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/sip-application-amba' || first === '/portal/sip-application-amba/' || this.sipApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/sip-application-realshield' || first === '/portal/sip-application-realshield/' || this.sipApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.sipApplication.customer.contactName = this.state.sipApplication.customer.contactName;
      this.sipApplication.customer.companyName = this.state.sipApplication.nameOfApplicant;
      this.sipApplication.customer.isSipApplication = 'True';
      this.sipApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.sipApplication.customer.partnerName = 'Mercer';
      }else if (this.getApplicantType === 'Realshield'){
        this.sipApplication.customer.partnerName = 'Realshield';
      }
      this.$store.dispatch('sipApplication/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.sipApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
};
</script>

<style scoped>

</style>
